<template>
  <div>
    <v-tabs v-model="tab" class="d-flex align-center justify-center">
      <v-tab href="#tab-1">Movimientos</v-tab>
      <v-tab href="#tab-2">Comparativa mensual</v-tab>
      <v-tab href="#tab-3">Comparativa anual</v-tab>
      <v-tab href="#tab-4"  v-if="businesstype == 'veterinary'">Pacientes</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-3">
        <div
          id="chart-demo"
          class="white pa-3 p-5"
          :style="{
            borderRadius: '5%',
          }"
        >
            <!-- year -->
          <v-row class="my-2">
            <v-col  cols="5" class="px-2">
              <v-select
                class="select-size-only"
                label="Selecciona Primer Año"
                v-model="start"
                :items="years"
                outlined
                attach
                dense
              ></v-select>
            </v-col>
            <v-col cols="5" class="px-2">
              <v-select
                class="select-size-only"
                label="Selecciona Segundo Año"
                v-model="end"
                :items="years"
                outlined
                attach
                dense
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-btn
                class="btn-save"
                type="default"
                @click="getTopProductsRange()"
              >Aplicar</v-btn>
            </v-col>
          </v-row>
            <!-- year -->
          
          <v-row>
            <v-col  cols="12" v-if="loadYear">
              <spinner key="year-3"/>
            </v-col>
          <v-col  cols="12" v-if="!loadYear">
            <DxChart
              id="chart"
              :data-source="chartDataCompareYear"
              :palette="['#64B5F6', '#81C784']"
              title="Comparación periodo actual y anterior"
            >
              <DxCommonSeriesSettings
                argument-field="MonthName"
                type="spline"
              />

              <DxSeries
                v-for="serie in architectureCompareYearSources"
                :key="serie.name"
                :value-field="serie.value"
                :name="serie.name"
              />

              <DxCommonAxisSettings>
                <DxGrid :visible="true" />
              </DxCommonAxisSettings>

              <DxArgumentAxis>
                <DxLabel />
              </DxArgumentAxis>
              <DxLegend
                vertical-alignment="top"
                horizontal-alignment="right"
              />
              <DxTooltip :enabled="true" :customize-tooltip="customTooltip"/>
              <DxExport :enabled="true" />
            </DxChart>
          </v-col>
          <v-col  cols="12" v-if="!loadYear">
            <div class="white pa-3">
              <DxChart
                :data-source="chartDataCompareYear"
                title="Crecimiento %"
              >
                <DxCommonSeriesSettings
                  argument-field="MonthName"
                  type="spline"
                />

                <DxSeries
                  value-field="PorcentajeCrecimiento"
                  name="Crecimiento %"
                />

                <DxValueAxis>
                  <DxLabel :customize-text="formatPercent" />
                </DxValueAxis>

                <DxTooltip :enabled="true" :customize-tooltip="customTooltipGrowth" />

                <DxLegend
                  vertical-alignment="top"
                  horizontal-alignment="right"
                />
              </DxChart>
            </div>
          </v-col>
          </v-row>
          <!--DxChart
            id="chart"
            :data-source="sharingStatisticsInfo"
            palette="Violet"
            title="Comparación periodo actual y anterior"
          >
            <DxCommonSeriesSettings :type="type" argument-field="month" />
            <DxCommonAxisSettings>
              <DxGrid :visible="true" />
            </DxCommonAxisSettings>
            <DxSeries
              v-for="architecture in architectureSources"
              :key="architecture.name"
              :value-field="architecture.value"
              :name="architecture.name"
            />
            <DxMargin :bottom="20" />
            <DxArgumentAxis :allow-decimals="true" :axis-division-factor="60">
              <DxLabel>
                <DxFormat type="decimal" />
              </DxLabel>
            </DxArgumentAxis>
            <DxLegend vertical-alignment="top" horizontal-alignment="right" />
            <DxExport :enabled="true" />
            <DxTooltip :enabled="true" />
          </DxChart-->
          <!--    <div class="options">
            <div class="caption">Options</div>
            <div class="option">
              <span>Series Type</span>
              <DxSelectBox :data-source="types" v-model="this.type" />
            </div>
          </div> -->
        </div>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <div
          id="chart-demo"
          class="white pa-3 p-5"
          :style="{
            borderRadius: '5%',
          }"
        >
          <div class="mt-5">

            <v-row dense>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-4">
                  <h4 class="mb-3 font-weight-medium">Primer Periodo</h4>
                  <div class="dx-field mb-1">
                    <v-select
                      v-model="selectedYearStart"
                      :items="years"
                      label="Selecciona año"
                      outlined
                      dense
                      attach
                      @change="getMonthsStart"
                    />
                  </div>
                  <div class="dx-field">
                    <v-select
                      v-model="startMonth"
                      :items="monthsStart"
                      item-text="monthName"
                      item-value="monthIndex"
                      label="Selecciona mes"
                      outlined
                      dense
                      attach
                      :loading="loadingStart"
                      :disabled="checkDateSelectedStart"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title
                            :class="{
                              'font-weight-bold': dbMonthsStart.some(
                                m => m.monthIndex === item.monthIndex
                              )
                            }"
                          >
                            {{ item.monthName }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-4">
                  <h4 class="mb-3 font-weight-medium">Segundo Periodo</h4>
                  <div class="dx-field mb-1">
                    <v-select
                      v-model="selectedYearEnd"
                      :items="years"
                      label="Selecciona año"
                      outlined
                      dense
                      attach
                      @change="getMonthsEnd"
                    />
                  </div>
                  <div class="dx-field">
                    <v-select
                      v-model="endMonth"
                      :items="monthsEnd"
                      item-text="monthName"
                      item-value="monthIndex"
                      label="Selecciona mes"
                      outlined
                      dense
                      attach
                      :loading="loadingEnd"
                      :disabled="checkDateSelectedEnd"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title
                            :class="{
                              'font-weight-bold': dbMonthsEnd.some(
                                m => m.monthIndex === item.monthIndex
                              )
                            }"
                          >
                            {{ item.monthName }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mt-4" justify="center">
              <DxButton
                text="Aplicar"
                type="default"
                styling-mode="contained"
                :width="160"
                @click="getTopProductsRangeWithMonths"
              />
            </v-row>

          </div>
          <v-row class="my-3">
            <v-col cols="12" v-if="loadMonth">
              <spinner  key="meses-2"/>
            </v-col>
            <v-col cols="12" lg="8"  v-if="!loadMonth">
              <DxChart
                id="chart"
                :data-source="sharingStatisticsInfo"
                :palette="['#64B5F6', '#AED581']"
                title="Comparación periodo actual y anterior"
              >
                <DxCommonSeriesSettings
                  argument-field="categoria"
                  type="bar"
                />

                <DxSeries
                  v-for="serie in architectureSources"
                  :key="serie.name"
                  :value-field="serie.value"
                  :name="serie.name"
                >
                  <DxLabel
                    :visible="true"
                    position="outside"
                    :customize-text="formatCurrencyObj"
                  />
                </DxSeries>

                <DxArgumentAxis>
                  <DxLabel />
                </DxArgumentAxis>

                <DxValueAxis>
                  <DxLabel :customize-text="formatCurrencyObj" />
                </DxValueAxis>

                <DxLegend
                  vertical-alignment="top"
                  horizontal-alignment="right"
                />

                <DxTooltip
                  :enabled="true"
                  :customize-tooltip="customTooltip"
                />
              </DxChart>
            </v-col>
            <v-col cols="12" lg="4" v-if="!loadMonth">
              <DxChart
                id="growth-chart"
                :data-source="mgrowthChartData"
                title="Crecimiento %"
              >
                <DxCommonSeriesSettings
                  type="bar"
                  argument-field="categoria"
                />

                <DxSeries
                  v-for="serie in mgrowthSeries"
                  :key="serie.name"
                  :value-field="serie.value"
                  :name="serie.name"
                  :color="mgrowthChartData[0]?.porcentaje >= 0 ? '#00C853' : '#D50000'"
                >
                <DxLabel
                  :visible="true"
                  position="top"
                  :customize-text="formatPercent"
                />
                </DxSeries>

                <DxArgumentAxis>
                  <DxLabel />
                </DxArgumentAxis>

                <DxValueAxis>
                  <DxLabel :customize-text="formatPercent" />
                </DxValueAxis>

                <DxTooltip :enabled="true" :customize-tooltip="tooltipPercent" />
              </DxChart>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
      <v-tab-item value="tab-1">
        <div
          id="chart-demo2"
          class="white pa-3 p-5"
          :style="{
            borderRadius: '5%',
          }"
        >
          <div class="mt-5">

            <v-row dense>
              <v-col cols="12" md="12">
                <v-card outlined class="pa-4">
                  <h4 class="mb-4 font-weight-medium">Periodo</h4>
                  <div class="row pa-2">
                    <div class="col-12 mb-1">
                      <v-select
                        v-model="selectedPeriod"
                        :items="periodList"
                        item-text="label"
                        item-value="value"
                        label="Selecciona el periodo"
                        outlined
                        dense
                        attach
                        @change="getPeriodRange"
                      />
                    </div>
                    <div class="col-12 mb-3" v-if="showDatesPeriod">
                      <date-picker
                        @dateSelected="
                          (value) => {
                            startPeriod = value;
                          }
                        "
                        label="Fecha inicial"
                        v-model="startPeriod"
                        :value="startPeriod"
                      />
                    </div>
                    <div class="col-12 mb-3" v-if="showDatesPeriod">
                      <date-picker
                        @dateSelected="
                          (value) => {
                            endPeriod = value;
                          }
                        "
                        label="Fecha final"
                        v-model="endPeriod"
                        :value="endPeriod"
                      />
                    </div>
                    <div class="col-12">
                      <DxButton
                      text="Aplicar"
                      type="default"
                      @click="getPeriodData"
                      />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

          </div>
          <v-row class="my-3">
            <v-col cols="12">
              <spinner v-if="loadPeriod" key="periodos-1"/>
              <DxChart
                v-else
                id="chart"
                :data-source="sharingStatisticsPeriod"
                palette="Soft Pastel"
                title="Movimientos de ventas"
              >
                <DxCommonSeriesSettings
                  argument-field="categoria"
                  type="spline"
                />

                <DxSeries
                  v-for="serie in architecturePeriod"
                  :key="serie.name"
                  :value-field="serie.value"
                  :name="serie.name"
                />
                
                <DxArgumentAxis>
                  <DxLabel />
                </DxArgumentAxis>

                <DxValueAxis>
                  <DxLabel :customize-text="formatCurrencyObj" />
                </DxValueAxis>

                <DxLegend
                  vertical-alignment="top"
                  horizontal-alignment="right"
                />
                <DxTooltip
                  :enabled="true"
                  :customize-tooltip="customTooltipPeriod"
                />
              </DxChart>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
      <v-tab-item value="tab-4" v-if="businesstype == 'veterinary'">
        <div
          id="chart-demo2"
          class="white pa-3 p-5"
          :style="{
            borderRadius: '5%',
          }"
        >
          <div class="mt-5">
            <v-row dense>
              <v-col cols="12" md="12">
                <v-card outlined class="pa-4">
                  <h4 class="mb-4 font-weight-medium">Periodo</h4>
                  <div class="row pa-2">
                    <div class="col-12 mb-1">
                      <v-select
                        v-model="selectedPeriod"
                        :items="periodList"
                        item-text="label"
                        item-value="value"
                        label="Selecciona el periodo"
                        outlined
                        dense
                        attach
                        @change="getPeriodRange"
                      />
                    </div>
                    <div class="col-12 mb-3" v-if="showDatesPeriod">
                      <date-picker
                        @dateSelected="
                          (value) => {
                            startPeriod = value;
                          }
                        "
                        label="Fecha inicial"
                        v-model="startPeriod"
                        :value="startPeriod"
                      />
                    </div>
                    <div class="col-12 mb-3" v-if="showDatesPeriod">
                      <date-picker
                        @dateSelected="
                          (value) => {
                            endPeriod = value;
                          }
                        "
                        label="Fecha final"
                        v-model="endPeriod"
                        :value="endPeriod"
                      />
                    </div>
                    <div class="col-12">
                      <DxButton
                      text="Aplicar"
                      type="default"
                      @click="getPeriodPatientData"
                      />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <v-row class="my-3">
            <v-col cols="12">
              <spinner v-if="loadPeriod" key="periodos-1"/>
              <DxChart
                v-else
                id="chart"
                :data-source="sharingStatisticsPeriodPatient"
                palette="Soft Pastel"
                title="Afluencia de pacientes"
              >
                <DxCommonSeriesSettings
                  argument-field="categoria"
                  type="spline"
                />

                <DxSeries
                  v-for="serie in architecturePeriodPatient"
                  :key="serie.name"
                  :value-field="serie.value"
                  :name="serie.name"
                />
                
                <DxArgumentAxis>
                  <DxLabel />
                </DxArgumentAxis>

                <DxValueAxis>
                  <DxLabel :customize-text="formatNumericObj" />
                </DxValueAxis>

                <DxLegend
                  vertical-alignment="top"
                  horizontal-alignment="right"
                />
                <DxTooltip
                  :enabled="true"
                  :customize-tooltip="customTooltipPeriodPatient"
                />
              </DxChart>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxCommonAxisSettings,
  DxGrid,
  DxExport,
  DxLegend,
  //DxMargin,
  DxTooltip,
  DxLabel,
  //DxFormat,
  DxValueAxis,
} from "devextreme-vue/chart";
import DatePicker from "../../components/DatePicker";
/* import DxSelectBox from 'devextreme-vue/select-box'; */

/* import { architectureSources, sharingStatisticsInfo } from './data.js'; */
import moment from "moment";
import DxButton from "devextreme-vue/button";
import spinner from "./spinner.vue";
export default {
  components: {
    /*  DxSelectBox, */
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxCommonAxisSettings,
    DxGrid,
    DxExport,
    DxLegend,
    //DxMargin,
    DxTooltip,
    DxLabel,
    //DxFormat,
    DxButton,
    DxValueAxis,
    DatePicker,
    spinner,
  },
  props:{
    branch:{
      type:Number,
      default: 0,
    },
    ambiente:{
      type:Number,
      default: 1,
    },
    autoLoad: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      startMonth: null,
      endMonth: null,
      start: 0,
      end: 0,
      years: [],
      monthsStart: [],
      monthsEnd: [],
      dbMonthsStart: [],
      dbMonthsEnd: [],
      tab: null,
      selectedYearStart: null,
      selectedYearEnd: null,
      startPeriod: null,
      endPeriod: null,
      selectedPeriod: 3,
      showDatesPeriod:false,
      periodList:[
        {
          value: 3,
          label:'Ultimos 3 meses'
        },
        {
          value: 6,
          label:'Ultimos 6 meses'
        }
        ,
        {
          value: 12,
          label:'Ultimos 12 meses'
        },
        {
          value: 18,
          label:'Ultimos 18 meses'
        },
        {
          value: 24,
          label:'Ultimos 24 meses'
        },
        {
          value: 'custom',
          label:'Definir un periodo'
        }
        
      ],
      loadingStart: null,
      loadingEnd: null,
      sharingStatisticsInfo: [
        /* {
        year: 1997,
        smp: 263,
        mmp: 208,
        cnstl: 9,
        cluster: 1,
      }, {
        year: 1999,
        smp: 169,
        mmp: 270,
        cnstl: 61,
        cluster: 7,
      }, {
        year: 2001,
        smp: 57,
        mmp: 261,
        cnstl: 157,
        cluster: 45,
      }, {
        year: 2003,
        smp: 0,
        mmp: 154,
        cnstl: 121,
        cluster: 211,
      }, {
        year: 2005,
        smp: 0,
        mmp: 97,
        cnstl: 39,
        cluster: 382,
      }, {
        year: 2007,
        smp: 0,
        mmp: 83,
        cnstl: 3,
        cluster: 437,
      } */
      ],
      architectureSources: [
        /*  { value: 'smp', name: 'SMP' },
         { value: 'mmp', name: 'MMP' },
         { value: 'cnstl', name: 'Cnstl' },
         { value: 'cluster', name: 'Cluster' }, */
      ],
      sharingStatisticsPeriod:[],
      sharingStatisticsPeriodPatient:[],
      architecturePeriod:[],
      architecturePeriodPatient:[],
      types: ["spline", "stackedspline", "fullstackedspline"],
      type: "spline",
      months: [
        { monthIndex: 1, monthName: "Enero" },
        { monthIndex: 2, monthName: "Febrero" },
        { monthIndex: 3, monthName: "Marzo" },
        { monthIndex: 4, monthName: "Abril" },
        { monthIndex: 5, monthName: "Mayo" },
        { monthIndex: 6, monthName: "Junio" },
        { monthIndex: 7, monthName: "Julio" },
        { monthIndex: 8, monthName: "Agosto" },
        { monthIndex: 9, monthName: "Septiembre" },
        { monthIndex: 10, monthName: "Octubre" },
        { monthIndex: 11, monthName: "Noviembre" },
        { monthIndex: 12, monthName: "Diciembre" },
      ],
      chartDataCompareYear:[],
      architectureCompareYearSources: [
        { name: 'Año Anterior', value: 'Total_Year1' },
        { name: 'Año Actual', value: 'Total_Year2' }
      ],
      mgrowthChartData: [],
      mgrowthSeries: [
        { name: 'Crecimiento (%)', value: 'porcentaje' }
      ],
      loadPeriod: false,
      loadMonth: false,
      loadYear: false,
      businesstype: (JSON.parse(localStorage.getItem("user"))?.businesstype || "")?.toLowerCase(),
    };
  },
  computed: {
    checkDateSelectedStart() {
      return this.selectedYearStart === null ? true : false;
    },
    checkDateSelectedEnd() {
      return this.selectedYearEnd === null ? true : false;
    },
  },
  watch: {
    branch(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getPeriodData();
      }
    }
  },
  mounted() {
    let currentYear = moment().format("YYYY");
    let previousYear = moment().subtract(1, "year").format("YYYY");
    this.start = previousYear;
    this.end = currentYear;
    this.architectureSources = [
      { value: currentYear, name: currentYear },
      { value: previousYear, name: previousYear },
    ];
    if (this.autoLoad) {
      this.loadInitialData();
    }

    // this.getLineData();
    //this.getTopProductsRange();
  },
  methods: {
    loadInitialData() {
      return Promise.allSettled([
        this.getYears(),
        this.getPeriodData(),
      ]);
    },
    getYears() {
      return this.$API.dashboard.getYears().then((response) => {
        this.years = response;
      });
    },
    getMonthsStart() {
      this.loadingStart = true;
      this.$API.dashboard
        .getMonths({ year: this.selectedYearStart })
        .then((response) => {
          this.monthsStart = this.months;
          this.dbMonthsStart = response;
        })
        .finally(() => {
          this.loadingStart = false;
        });
    },
    getMonthsEnd() {
      this.loadingEnd = true;
      this.$API.dashboard
        .getMonths({ year: this.selectedYearEnd })
        .then((response) => {
          this.monthsEnd = this.months;
          this.dbMonthsEnd = response;
        })
        .finally(() => {
          this.loadingEnd = false;
        });
    },
    getLineData() {
      this.$API.dashboard.LineGraph().then((response) => {
        this.sharingStatisticsInfo = response;
      });
    },
    getTopProductsRange() {
      this.loadYear = true;
      try {
        const params = {
          start: this.start,
          end: this.end,
          branch: this.branch,
          ambiente: this.ambiente,
        }
        this.$API.dashboard.getYearsCustom(params).then((response) => {
          this.chartDataCompareYear = response;
          if (this.chartDataCompareYear.length > 0) {
            this.chartDataCompareYear = this.chartDataCompareYear.map(item => ({
              ...item,
              Total_Year1: Number(item.Total_Year1),
              Total_Year2: Number(item.Total_Year2),
              Diferencia: Number(item.Diferencia),
              PorcentajeCrecimiento: Number(item.PorcentajeCrecimiento)
            }));
            this.architectureCompareYearSources = [
              { name: 'Año '+this.start, value: 'Total_Year1' },
              { name: 'Año '+ this.end, value: 'Total_Year2' }
            ]
          }
        }).finally(()=> this.loadYear = false);
        
      } catch (error) {
        console.error(error);
      }
      
    },
    customTooltip(info) {
      return {
        text: `${info.argumentText} ${info.seriesName}: $${this.formatCurrency(info.value)}`
      };
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatCurrencyObj(e) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'USD',
      }).format(e.value);
    },
    formatNumericObj(e) {
      return new Intl.NumberFormat('en-US').format(e.value);
    },
    customTooltipGrowth(info) {
      return {
        text: `${info.argumentText}: ${info.value.toFixed(2)} %`
      };
    },
    formatPercent(e) {
      return `${e.value}%`;
    },
    tooltipPercent(info) {
      return {
        text: `${info.value}%`
      };
    },
    async getPeriodData() {
      this.loadPeriod = true;
      try {
        this.getPeriodRange();
        const datesRange = {
          start: this.formatDatePicker(this.startPeriod) ,
          end: this.formatDatePicker(this.endPeriod),
          branch: this.branch,
          ambiente: this.ambiente,
        };
        
        const rs = await this.$API.dashboard.getCustomPeriod(datesRange);
        if (rs && rs.length > 0) {
          this.sharingStatisticsPeriod = rs.map(item => ({
            categoria: item.Periodo,
            total: Number(item.TotalPriceNotIva),
            porcentaje: item.PorcentajeCrecimiento_MesAnterior,
            mes: item.NombreMes,
            anio: item.Anio
          })).reverse();
          this.architecturePeriod = [
            { value: 'total', name: 'Total mensual' }
          ];
        }
      } catch (error) {
        console.log(error);
        
      }finally{
        this.loadPeriod = false;
      }
    },
    async getPeriodPatientData() {
      this.loadPeriod = true;
      try {
        this.getPeriodRange();
        const datesRange = {
          start: this.formatDatePicker(this.startPeriod) ,
          end: this.formatDatePicker(this.endPeriod),
          branch: this.branch
        };
        
        const rs = await this.$API.dashboard.getCustomPeriodPatient(datesRange);
        if (rs && rs.length > 0) {
          this.sharingStatisticsPeriodPatient = rs.map(item => ({
            categoria: item.mes,
            total: Number(item.pacientes_mes),
            porcentaje: item.variacion_porcentual,
            mes: item.nombre_mes,
          })).reverse();
          this.architecturePeriodPatient = [
            { value: 'total', name: 'Total mensual' }
          ];
        }
      } catch (error) {
        console.log(error);
        
      }finally{
        this.loadPeriod = false;
      }
    },
    formatDatePicker(value) {
      if (!value) return null;
      if (value instanceof Date) {
        return value.toISOString().slice(0, 10);
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const [d, m, y] = value.split('/');
        return `${y}-${m}-${d}`;
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value;
      }

      return null;
    },
    getPeriodRange() {
      if(this.selectedPeriod && isFinite(this.selectedPeriod)){
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const start = new Date(
        now.getFullYear(),
        now.getMonth() - (this.selectedPeriod - 1),
        1
      );
      const format = (date) => date.toISOString().split("T")[0];
      this.startPeriod = format(start);
      this.endPeriod = format(end);
      this.showDatesPeriod = false;
      }else {
        this.startPeriod = moment().format('DD/MM/YYYY');
        this.endPeriod = moment().format('DD/MM/YYYY');
        this.showDatesPeriod = true;
      }
    },
    customTooltipPeriod(info){
      const porcentaje = info.point.data.porcentaje;
      const fecha = info.argumentText;

      return {
        html: `
          <div style="
            text-align: center;
            padding: 6px 10px;
            line-height: 1.4;
          ">
          <strong>${fecha}</strong><br/>
          Monto: $${Number(info.value).toLocaleString('en-US', { minimumFractionDigits: 2 })}
          ${porcentaje !== null ? `<br/>Variación: ${porcentaje}%` : ''}
        </div>
        `
      };
    },
    customTooltipPeriodPatient(info){
      const porcentaje = info.point.data.porcentaje;
      const fecha = info.argumentText;

      return {
        html: `
          <div style="
            text-align: center;
            padding: 6px 10px;
            line-height: 1.4;
          ">
          <strong>${fecha}</strong><br/>
          Pacientes: ${Number(info.value)}
          ${porcentaje !== null ? `<br/>Variación: ${porcentaje}%` : ''}
        </div>
        `
      };
    },
    getTopProductsRangeWithMonths() {
      this.loadMonth = true;
      
      try {
        const datesRange = {
        startYear: this.selectedYearStart,
        endYear: this.selectedYearEnd,
        startMonth: this.startMonth,
        endMonth: this.endMonth,
        branch: this.branch,
        ambiente: this.ambiente,
      };
       this.$API.dashboard.getYearsMonthsCustom(datesRange).then((response) => {
        const parsed = {
          categoria: 'Total',
          Periodo1: Number(response.PriceNotIva_Periodo1),
          Periodo2: Number(response.PriceNotIva_Periodo2),
        };

        this.sharingStatisticsInfo = [parsed];
        this.architectureSources = [
          {
            name: response.Periodo1,
            value: 'Periodo1',
          },
          {
            name: response.Periodo2,
            value: 'Periodo2',
          },
        ];
        this.mgrowthChartData = [
          {
            categoria: 'Crecimiento',
            porcentaje: Number(response.PorcentajeCrecimiento)
          }
        ];
      }).finally(()=> this.loadMonth = false);
      } catch (error) {
        console.error(error)  
      }
     
    },
    showDateNames() {
      const getMonthName = (months, targetMonth) => {
        const foundMonth = Array.isArray(months)
          ? months.find((month) => month.monthIndex === targetMonth)
          : months && months.monthIndex === targetMonth
          ? months.monthName
          : null;

        return foundMonth ? foundMonth.monthName : null;
      };

      const first =
        getMonthName(this.monthsStart, this.startMonth) +
        " del " +
        this.selectedYearStart;
      const second =
        getMonthName(this.monthsEnd, this.endMonth) + " del " + this.selectedYearEnd;
      console.log(first, second);
      return { first, second };
    },
  },
};
</script>
<style>
.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
  margin-top: 20px;
}

.option {
  margin-top: 10px;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option > span {
  margin-right: 14px;
}

.option > .dx-widget {
  display: inline-block;
  vertical-align: middle;
}
.select-size-only {
  width: 100%;
}
.select-size {
  max-width: 150px !important;
  min-width: 100px !important;
  margin-right: 5px !important;
}

.field-size {
  margin-left: 30px !important;
}

@media screen and (max-width: 1495px) {
  .field-size {
    margin-left: 0 !important;
  }

  .select-size {
    max-width: 60%;
  }
}
</style>
